<script setup>
const props=defineProps({seedId:{type:[String,Number],required:true}});
const {data:families}=await useFetch('/api/catalog/plant-families',{key:'plant-families-'+props.seedId,query:{id:props.seedId}});
</script>
<template>
 <section v-if="families?.length" id="families" class="plantcard-section" aria-labelledby="plant-families-title">
  <header class="plantcard-heading"><div><h2 id="plant-families-title">Сорта этого семейства</h2><p>Общее происхождение, авторская серия или местная традиция.</p></div></header>
  <div v-for="family in families" :key="family.slug" class="plantcard-panel family-panel">
   <header class="plantcard-heading"><div><h3><NuxtLink :to="'/catalog/families/'+family.slug">{{family.title}}</NuxtLink></h3></div><NuxtLink class="plantcard-link" :to="'/catalog/families/'+family.slug">Все сорта семейства ({{family.total}}) →</NuxtLink></header>
   <CatalogPlantPreviewLinks v-if="family.plants.length" :plants="family.plants" />
   <p v-else class="plantcard-small">Другие сорта появятся после проверки карточек.</p>
   <footer class="family-footer"><NuxtLink v-if="family.article_id" class="plantcard-link" :to="'/feed/'+family.article_id">О семействе в статье →</NuxtLink><details v-if="family.description"><summary>О семействе</summary><p>{{family.description}}</p></details></footer>
  </div>
 </section>
</template>
<style scoped>
.family-panel{margin-block:12px;min-width:0;padding:20px}
.family-panel h3{margin:0;font-size:20px;line-height:28px}
.family-panel .plantcard-heading{align-items:start;flex-wrap:wrap;gap:8px 16px;margin-bottom:12px}
.family-panel .plantcard-heading>div{flex:1 1 280px}
.family-panel .plantcard-heading p{font-size:14px;line-height:20px;margin-top:4px}
.family-panel p,.family-panel a{overflow-wrap:anywhere}
.family-footer{display:flex;justify-content:space-between;align-items:flex-start;gap:8px 16px;flex-wrap:wrap;margin-top:8px;font-size:14px;line-height:20px}
.family-footer>.plantcard-link,.family-footer summary{display:flex;align-items:center;min-height:44px;font-size:14px}
.family-footer summary{cursor:pointer;color:var(--uo-color-text-secondary)}
.family-footer details[open]{flex-basis:100%}
.family-footer details p{margin-top:4px;font-size:14px;line-height:20px}
@media(max-width:767px){.family-panel{padding:16px}.family-panel h3{font-size:18px;line-height:24px}.family-panel .plantcard-heading>.plantcard-link{min-height:44px;font-size:14px}}
</style>
